import { useSignalEffect, type Signal } from "@preact/signals";
import { For } from "@preact/signals/utils";
import { useCallback } from "preact/hooks";

export default function Selector({ keys, active, withLive = true }: { keys: Signal<string[]>, active: Signal<string>, withLive?: boolean }) {
	useSignalEffect(() => {
		if (active.value) {
			window.location.hash = active.value;
		}
	});

	const wheel = useCallback((e: WheelEvent) => {
		if (e.deltaY == 0) {
			return;
		}

		const _keys = [...keys.peek()];
		if (withLive) {
			_keys.unshift("live");
		}
		const _cur = active.peek();
		let pos = _keys.findIndex((k) => k == _cur);
		if (pos == -1) {
			return;
		}

		if (e.deltaY < 0) {
			pos = Math.max(0, pos - 1);
		} else if (e.deltaY > 0) {
			pos = Math.min(_keys.length - 1, pos + 1);
		}
		active.value = _keys.at(pos) ?? "";
	}, []);

	return (
		<select value={active.value} onWheel={wheel} onChange={(e) => {
			active.value = e.currentTarget.value;
		}}>
			{withLive && (
				<>
					<option value="live">🔴 Live</option>
					<hr />
				</>
			)}
			<For each={keys}>
				{(item) => <option value={item}>{item}</option>}
			</For>
		</select>
	);
}
